import * as d3 from 'd3'
export default {

  methods: {

    gauge_Plan() {

      let angle = this.angle
      let col = this.columns.find(f=> f.code == 'A_PRO')
      let prog = this.rawData[col.code]/100
      let fc = 270 + prog * 180

      let plan = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      plan
      .append('line')
      .attr('x1', 0).attr('y1', -this.circle.radius - 10)
      .attr('x2', 0).attr('y2', angle.inY)
      .attr('stroke', col.stroke).attr('stroke-width', 1)
      .attr('transform', () => `rotate(${270}, 0, 0)`)
      .transition().duration(500)
      .attr('transform', () => `rotate(${fc}, 0, 0)`)

      plan
      .append('circle')
      .attr('cx', 0).attr('cy', -this.circle.radius - 10)
      .attr('r', 2).attr('fill', 'white')
      .attr('stroke', col.stroke).attr('stroke-width', 1)
      .attr('transform', () => `rotate(${270}, 0, 0)`)
      .transition().duration(500)
      .attr('transform', () => `rotate(${fc}, 0, 0)`)
    
    },

  }
}